import React from 'react';
import classNames from 'classnames';
import { Progress } from 'antd';
import Chart from '@/business-components/chart';
import TitleTag from '@/components/titletag';
import Tooltip from '@/components/tooltip';
import Wuliu from 'assets/wuliu.svg';
import styles from './index.module.scss';

export default function Efficiency({ data }) {
  return (
    <Chart
      title={
        <span className={styles.title}>
          物流配送效率
          <Tooltip
            title={
              <>
                <p>物流配送效率指品牌官方旗舰店物流服务评分。</p>
                <p>数据来源：CBNData数据库</p>
              </>
            }
            placement="right"
          />
        </span>
      }
      panelClassName={styles.potentialChart}
    >
      <div className={classNames('flex-row-nowrap', 'flex-start-center', styles.potential)}>
        {data?.map((item, index) => (
          <div className={classNames(styles.dataCard, styles.cardItem)} key={index}>
            <TitleTag style={{ marginBottom: '12px', fontSize: '16px' }}>{item?.chName}</TitleTag>
            <div className={classNames('flex-row-nowrap', 'flex-between-center', styles.dataItem)} key={index}>
              <div className={classNames('flex-row-nowrap', 'flex-between-center')}>
                <Wuliu />
                <span style={{ marginLeft: '6px' }}>物流服务</span>
              </div>
              {/*{item?.dsrValue}*/}
              {!item?.dsrValue || item?.dsrValue !== '0.0' ? item?.dsrValue : ''}
              <Progress
                style={{ width: '100px' }}
                percent={(+item?.dsrValue / 5) * 100}
                strokeColor="#f75c2f"
                showInfo={false}
              />
              <div className={styles.point}>
                {!item?.dsrValue || item?.dsrValue !== '0.0' ? (
                  item?.dsrValue
                ) : (
                  <span className={styles.emptyStateText}>暂无数据</span>
                )}
              </div>
              {/* <div className={styles.desc}>持平于同行</div> */}
            </div>
          </div>
        ))}
      </div>
    </Chart>
  );
}
